import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./CorporatePageElementsCss/CorporatePaymentSuccess.css";


const CorporatePaymentSuccess = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    try {
      // Decode Base64
      const decoded = atob(token);
      const parsedData = JSON.parse(decoded);

      // Validate success
      if (parsedData?.STATUS === "TXN_SUCCESS") {
        setPaymentData(parsedData);
      } else {
        navigate("/corporate");
      }
    } catch (err) {
      console.error("Invalid payment data", err);
      navigate("/corporate");
    }
  }, [token, navigate]);

  if (!paymentData) return null;

  return (
    <div className="cps-wrapper">
      <div className="cps-card">
        <div className="cps-icon">✔</div>

        <h2>Payment Successful</h2>

        <p>Thank you for your payment.</p>

        <div style={{ marginTop: 20, textAlign: "left" }}>
          <p><b>Order ID:</b> {paymentData.ORDERID}</p>
          <p><b>Transaction ID:</b> {paymentData.TXNID}</p>
          <p><b>Amount:</b> ₹{paymentData.TXNAMOUNT}</p>
          <p><b>Payment Mode:</b> {paymentData.PAYMENTMODE}</p>
          <p><b>Date:</b> {paymentData.TXNDATE}</p>
        </div>

        <button
          style={{ marginTop: 30 }}
          onClick={() => navigate("/corporate")}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default CorporatePaymentSuccess;
